import React, { useEffect, useState } from "react";
import "./App.css";
import Board from "./Table";
import rankingCsv from "./ranking.csv";
import { readString } from "react-papaparse";

// Known section words that the reviews use as headers (sometimes with a
// trailing colon, sometimes without).
const SECTION_HEADS = /^(story|set|puzzles|gameplay|design|atmosphere|theme|story\/gameplay)$/i;

// Turn a raw multi-line review string from the CSV into structured blocks.
// k: "para" | "head" | "plus" | "minus" | "meta"
function parseReview(raw) {
  if (!raw) return [];
  return raw
    .split("\n")
    .map((l) => l.trim())
    .filter((l) => l.length)
    .map((l) => {
      if (/^\+\s/.test(l)) return { k: "plus", t: l.replace(/^\+\s+/, "") };
      if (/^[-–]\s/.test(l)) return { k: "minus", t: l.replace(/^[-–]\s+/, "") };
      if (/^(played|stats)\s*:/i.test(l)) return { k: "meta", t: l };
      if (/^[A-Za-z/ ]{1,22}:$/.test(l)) return { k: "head", t: l.replace(/:$/, "") };
      if (SECTION_HEADS.test(l)) return { k: "head", t: l };
      return { k: "para", t: l };
    });
}

export default function App() {
  const [rooms, setRooms] = useState([]);
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(rankingCsv)
      .then((response) => response.text())
      .then((responseText) => {
        readString(responseText, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            const parsed = results.data
              .filter((v) => v && v.name)
              .map((v, i) => ({
                rank: i + 1,
                name: v.name,
                company: v.company,
                city: v.city,
                region: v.region,
                tags: (v.tags || "").split("|").filter((t) => t),
                website: v.website,
                players: v.players,
                rating: parseInt(v.rating, 10) || 0,
                status: (v.status || "").toLowerCase(),
                review: parseReview(v.review),
              }));

            // Regions in order of first appearance (rank order).
            const seen = [];
            parsed.forEach((r) => {
              if (r.region && seen.indexOf(r.region) === -1) seen.push(r.region);
            });

            setRooms(parsed);
            setRegions(seen);
            setLoading(false);
          },
        });
      });
  }, []);

  return <Board rooms={rooms} regions={regions} loading={loading} />;
}
